const GOOGLE_LOGIN_CLIENT_ID = "755714274654-reca5u348b08114hm094a3rna596njg4.apps.googleusercontent.com";

export default GOOGLE_LOGIN_CLIENT_ID;
